import React, { useCallback, useState } from 'react';
import { CHAT_FLOW_STEPS, useCurrentChat } from '@guuru/chat-web';
import ChatRenderText from '../Text';
import ChatPredictOptions from './ChatPredictOptions';
import SmartFormPredictOptions from './SmartFormPredictOptions';

interface ChatRenderPredictionConfirmationProps {
  message: React.ComponentProps<typeof ChatPredictOptions>['message'] & {
    text: string;
    metadata?: {
      subscriptionPriority: number;
      subscriptionTarget: string;
    };
  };
  readOnly?: boolean;
  preview?: boolean;
  onRunNextStep?: (_: {
    response: string;
    text: string;
    smartFormStyle: boolean;
    subscriptionPriority?: number;
    subscriptionTarget?: string;
  }) => void;
}

const ChatRenderPredictionConfirmation = function ({
  message,
  readOnly = false,
  preview = false,
  onRunNextStep = () => {},
}: ChatRenderPredictionConfirmationProps) {
  const { flowStep } = useCurrentChat();
  const requestIntentOption = flowStep === CHAT_FLOW_STEPS.makePrediction;
  const [showOptions, setShowOptions] = useState(
    preview || requestIntentOption,
  );

  const {
    smartFormStyle = false,
    metadata: { subscriptionPriority, subscriptionTarget } = {},
  } = message;

  const handleSelection = useCallback(
    (option: string, optionTranslated: string) => {
      setShowOptions(false);
      return onRunNextStep({
        response: option,
        text: optionTranslated,
        smartFormStyle,
        subscriptionPriority,
        subscriptionTarget,
      });
    },
    [onRunNextStep, smartFormStyle, subscriptionPriority, subscriptionTarget],
  );

  if (readOnly) {
    return <ChatRenderText message={message} />;
  }

  const PredictOptions = smartFormStyle
    ? SmartFormPredictOptions
    : ChatPredictOptions;
  return (
    <PredictOptions
      message={message}
      onSelect={handleSelection}
      showOptions={showOptions && flowStep === CHAT_FLOW_STEPS.makePrediction}
    />
  );
};

export default ChatRenderPredictionConfirmation;
